<template>
  <v-dialog v-model="dialog" width="800" persistent>
    <template v-slot:activator="{ on, attrs }">
      <div style="border: #fafafa 2px solid; border-radius: 4px; margin-top: -4px" class="mr-1" v-bind="attrs" v-on="on">
        <v-btn color="info" class="elevation-0" min-width="0" width="250">
          <v-icon class="mr-1">mdi-file-excel</v-icon>
          Import Excel
        </v-btn>
      </div>
    </template>

    <v-card class="d-flex flex-column fill-height">
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card-title class="form-header">
        <span style="font-size: 16px">IMPORT USERS FROM EXCEL</span>
        <v-spacer/>
        <v-btn :disabled="loading" icon small @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-5 overflow-y-auto" style="height: 400px">
        <v-layout class="fill-height" column>
          <div style="flex: none; height: 50px; border-bottom: 1px solid lightgray; margin-bottom: 16px">
            <v-layout align-center class="fill-height">
              <v-icon color="grey" class="mr-2">mdi-information-outline</v-icon>
              <span style="font-size: 13px; color: grey">
                Accepted: <b>.xlsx</b>, <b>.xls</b>, <b>.csv</b> &nbsp;|&nbsp; Max size: <b>5MB</b>
              </span>
            </v-layout>
          </div>
          <v-layout class="fill-height py-2" align-center justify-center>
            <file-upload
                extensions="csv,xlsx,xls"
                style="border-radius: 8px; width: 100%; height: 100%;"
                :style="{'border': `1px dashed ${color}`}"
                ref="upload"
                v-model="file"
                :drop="true"
                class="pt-2"
            >
              <template>
                <v-layout column justify-center class="py-6 fill-height" style="align-items: center" v-if="!file || !file.length">
                  <v-icon size="80">mdi-cloud-upload-outline</v-icon>
                  <h3>Upload user file</h3>
                  <span style="font-size: 13px; color: var(--v-primary-base)">Support file: *.csv | *.xlsx | *.xls</span>
                  <span style="font-size: 13px">Click to select file or drop it here</span>
                </v-layout>
                <v-layout column justify-center class="py-2 fill-height" style="align-items: center" v-else>
                  <div style="width: 150px; border: 1px solid lightgray; border-radius: 8px">
                    <v-layout align-center justify-center class="fill-height">
                      <v-icon size="130" :color="color">mdi-microsoft-excel</v-icon>
                    </v-layout>
                  </div>
                  <div :style="{'color': color}" style="height: 50px; width: 100%; font-size: 13px;" class="mt-4 text-center">
                    {{ file[0].name }}
                  </div>
                </v-layout>
              </template>
            </file-upload>
            <v-hover v-slot="{ hover }">
              <v-btn
                  v-if="file && file.length"
                  width="55"
                  height="100%"
                  @click="removeFile"
                  class="elevation-0 ml-2"
                  :color="hover ? 'red' : '#ff000024'"
                  dark
                  style="border: 1px solid red !important; border-radius: 8px"
              >
                <v-icon :color="hover ? 'white' : 'red'">mdi-delete</v-icon>
              </v-btn>
            </v-hover>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" width="165" @click="submit">
          <v-icon class="mr-1">mdi-upload-outline</v-icon>
          Import
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueUploadComponent from 'vue-upload-component'
import {importUsersFromExcel} from "@/backend"

export default {
  name: "ImportUserForm",
  components: {'file-upload': VueUploadComponent},
  data() {
    return {
      dialog: false,
      loading: false,
      file: undefined,
      color: 'green',
      extensions: ['csv', 'xlsx', 'xls'],
      validFile: false,
    }
  },
  watch: {
    file(val) {
      if (val && val.length) {
        const ext = val[0].name.split('.').pop().toLowerCase()
        if (!this.extensions.includes(ext)) {
          this.color = 'red'
          this.validFile = false
          this.$store.commit('message/SHOW_ERROR', 'File format not supported')
        } else {
          this.color = 'green'
          this.validFile = true
        }
      } else {
        this.validFile = false
        this.color = 'green'
      }
    },
    dialog(val) {
      if (!val) {
        this.file = undefined
        this.color = 'green'
        this.validFile = false
      }
    }
  },
  methods: {
    removeFile() {
      this.file = undefined
      this.color = 'green'
      this.validFile = false
    },
    async submit() {
      if (!this.validFile) {
        this.$store.commit('message/SHOW_ERROR', 'Please select a valid file')
        return
      }
      try {
        this.loading = true
        const res = await importUsersFromExcel(this.file[0].file)
        const {created, errors} = res.data
        if (errors && errors.length) {
          this.$store.commit('message/SHOW_ERROR', `Created ${created} users. Errors: ${errors.join('; ')}`)
        } else {
          this.$store.commit('message/SHOW_SUCCESS', `Successfully created ${created} users`)
        }
        this.dialog = false
        this.$emit('getUser')
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
/deep/ .file-uploads label {
  cursor: pointer !important;
}
</style>
